// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".product-card__image[data-v-77cb6dca]{width:100%;-o-object-fit:cover;object-fit:cover;margin-bottom:10px;aspect-ratio:1/1}.description__title[data-v-77cb6dca]{font-weight:400!important;margin-bottom:0!important}.description__title[data-v-77cb6dca],.product-grid-item__price[data-v-77cb6dca],.product-grid-item__price *[data-v-77cb6dca]{font-size:14px!important;font-family:\"Jost\",sans-serif!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
